import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import health from "./modules/health";
import karte from "./modules/karte";
import selvy from "./modules/selvy";
import users from "./modules/users";
import labels from "./modules/labels";
import validations from "./modules/validations";
import aiPrediction from "./modules/aiPrediction"

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  namespaced: true,
  modules: {
    auth,
    health,
    karte,
    selvy,
    users,
    labels,
    validations,
    aiPrediction
  },
  actions: {
    clearAll({ commit }) {
      commit("auth/clear");
      commit("health/clear");
      commit("karte/clear");
      commit("selvy/clear");
      commit("users/clear");
    }
  }
});
